// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.field:not(:last-child),
.field-pair:not(:last-child) {
  margin-bottom: 1rem;
}

@media screen and (min-width: 769px), print {
  .field-pair {
    display: flex;
    min-height: 38px;
    align-items: center;
    justify-content: space-between;
  }
  .stacked-form .field-pair,
  .stacked-form.field-pair {
    display: block;
  }
  .field-content {
    flex: 4 1;
    min-width: 0;
  }
  .field-label {
    flex: 1;
    margin-right: 0.5rem;
    text-align: left;
  }
  .stacked-form .field-label {
    width: fit-content;
    text-align: initial;
    margin-bottom: 8px;
  }
  .field-body {
    flex: 1;
  }
  .label {
    display: flex;
    gap: 0.25rem;
    align-items: center;
  }
}
.field-error-message {
  color: red;
  margin-top: 3px;
}
.field-error-message::before {
  display: inline;
  content: "⚠ ";
}

.field-info-message {
  margin-top: 3px;
}
.field-info-message::before {
  display: inline;
  content: "ℹ️ ";
}

.form-control.has-error {
  border-color: #ff3860;
  background: #ffeeee;
}
.form-control.has-error:focus {
  border-color: #ff3860;
  box-shadow: 0 0 0 0.125em rgba(255, 56, 96, 0.25);
}
.form-control.has-error:active {
  border-color: #ff3860;
  box-shadow: 0 0 0 0.125em rgba(255, 56, 96, 0.25);
}

.form-control:focus,
.form-control.focused {
  background: #dce7f4;
  box-shadow: none;
  border-color: #2d73b9;
}

.field-decoration-wrapper {
  display: flex;
  background: #f8f8f8;
  padding: 8px 8px 8px 8px;
}
.field-decoration-wrapper .field-decoration-content {
  flex: 1 1;
  align-self: center;
}
.field-decoration-wrapper .field-decoration {
  align-self: center;
}

.array-wrapper > div {
  margin-bottom: 0.5rem;
}

.array-wrapper-moving {
  cursor: grabbing !important;
}
.array-wrapper-moving i,
.array-wrapper-moving .field-decoration-wrapper,
.array-wrapper-moving label,
.array-wrapper-moving input,
.array-wrapper-moving div {
  cursor: grabbing !important;
}

.button-icon {
  outline: none;
  padding: 0;
  vertical-align: initial;
}
.button-icon:focus {
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/assets/css/field.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEd;;EAEE,mBAAA;AAAJ;;AAIA;EACE;IACE,aAAA;IACA,gBAAA;IACA,mBAAA;IACA,8BAAA;EADF;EAGA;;IAEE,cAAA;EADF;EAIA;IACE,SAAA;IAEA,YAAA;EAHF;EAMA;IACE,OAAA;IACA,oBAAA;IACA,gBAAA;EAJF;EAOA;IACE,kBAAA;IACA,mBAAA;IACA,kBAAA;EALF;EAOA;IACE,OAAA;EALF;EAOA;IACE,aAAA;IACA,YAAA;IACA,mBAAA;EALF;AACF;AAQA;EACE,UAAA;EACA,eAAA;AANF;AAOE;EACE,eAAA;EACA,aAAA;AALJ;;AASA;EACE,eAAA;AANF;AAOE;EACE,eAAA;EACA,cAAA;AALJ;;AAUE;EACE,qBAAA;EACA,mBAAA;AAPJ;AAQI;EACE,qBAAA;EACA,iDAAA;AANN;AAQI;EACE,qBAAA;EACA,iDAAA;AANN;;AAYA;;EAEE,mBAAA;EACA,gBAAA;EACA,qBAAA;AATF;;AAaA;EACE,aAAA;EAQA,mBAAA;EACA,wBAAA;AAjBF;AASE;EACE,SAAA;EACA,kBAAA;AAPJ;AASE;EACE,kBAAA;AAPJ;;AAaA;EACE,qBAAA;AAVF;;AAaA;EACE,2BAAA;AAVF;AAWE;;;;;EAKE,2BAAA;AATJ;;AAaA;EACE,aAAA;EACA,UAAA;EACA,uBAAA;AAVF;AAWE;EACE,gBAAA;AATJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
